import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toThunkRejectValue } from "../../../Common/isRequestCanceled";
import { getSessionAuthHeader, withSessionFields } from "../../../Common/sessionAuth";
import {
  BASE_URL,
  LIST_ALL_PERMISSION,
  DELETE_SINGLE_PERMISSION,
  FETCH_PERMISSION_LIST,
  ADD_EDIT_PERMISSION_LIST,
} from "../../../Constants/Config";
import { ToastifyAlert } from "../../../CommonComponents/ToastifyAlert";

const initialState = {
  loading: false,
  permissionData: [],
  successMessage: "",
  error: "",
};

// Generate pening , fulfilled and rejected action type
export const fetchPermissionData = createAsyncThunk(
  "permission/fetchPermissionData",
  async (data, { rejectWithValue }) => {
    const { token, ...userData } = data;
    try {
      const response = await axios.post(
        BASE_URL + LIST_ALL_PERMISSION,
        userData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.status === "success") {
        return response.data.data;
      }
    } catch (error) {
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

export const deletePermission = createAsyncThunk(
  "permission/deletePermission",
  async (data, { rejectWithValue }) => {
    const { token, ...dataNew } = data;
    try {
      const response = await axios.post(
        BASE_URL + DELETE_SINGLE_PERMISSION,
        dataNew,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response) {
        // ToastifyAlert("Permission Deleted Successfully!", "success");
        ToastifyAlert("Deleted Successfully", "success");
        return {
          id: data.id,
        };
      }
    } catch (error) {
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

export const fetchPermissionList = createAsyncThunk(
  "permission/fetchPermissionList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(BASE_URL + FETCH_PERMISSION_LIST, withSessionFields(), {
        headers: getSessionAuthHeader(),
      });
      return response?.data;
    } catch (error) {
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

export const AddEditMainPermission = createAsyncThunk(
  "permission/AddEditMainPermission",
  async (data, { rejectWithValue }) => {
    const { token, ...dataNew } = data;
    try {
      const response = await axios.post(
        BASE_URL + ADD_EDIT_PERMISSION_LIST,
        dataNew,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response?.data;
    } catch (error) {
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);
const taxesSlice = createSlice({
  name: "permission",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchPermissionData.pending, (state) => {
      state.permissionData = [];
      state.loading = true;
      state.error = "";
    });
    builder.addCase(fetchPermissionData.fulfilled, (state, action) => {
      state.loading = false;
      state.permissionData = action.payload;
      state.error = "";
    });
    builder.addCase(fetchPermissionData.rejected, (state, action) => {
      state.loading = false;
      state.permissionData = {};
      state.error = action.error.message;
    });

    builder.addCase(deletePermission.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deletePermission.fulfilled, (state, action) => {
      state.loading = false;
      state.successMessage = action?.payload?.message;
      state.permissionData = state.permissionData.filter(
        (item) => item && item.id !== action.payload.id
      );
      state.error = ""; // Reset the error message
    });
    builder.addCase(deletePermission.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });

    builder.addCase(fetchPermissionList.pending, (state) => {
      state.loading = true;
      state.permissionData = [];
      state.error = "";
    });
    builder.addCase(fetchPermissionList.fulfilled, (state, action) => {
      state.loading = false;
      state.permissionData = action.payload;
      state.error = "";
    });
    builder.addCase(fetchPermissionList.rejected, (state, action) => {
      state.loading = false;
      state.permissionData = {};
      state.error = action.error.message;
    });
  },
});

export default taxesSlice.reducer;
